import React, { PropTypes } from 'react';
import DataTable from "../DataTable";
import { inject, observer } from "mobx-react/index";
import { observable, toJS } from 'mobx';
import { BASE_URL } from "../../config";
import * as api from "../../actions/api";
import Dropzone from "../Dropzone";

@inject('inventoryProductStore')
@observer
class ProdctRelatedFileList extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };
  @observable product = null;

  componentWillMount() {
    const { params: { id } } = this.props;
    this.fetchProduct(id);
  }

  componentWillReceiveProps(nextProps) {
    const { params: { id } } = nextProps;
    if (this.props.params.id !== id) this.fetchProduct(id);
  }

  fetchProduct = (id) => {
    const { inventoryProductStore } = this.props;
    let product = inventoryProductStore.findById(id);
    this.relatedFilesSlug = `inventory/product/${id}/files`;
    this.product = { ...product, relatedFiles: [], images: [] };
    inventoryProductStore.fetchProductById(id).then(item => {
      this.product.images = item.images;
      item.files && item.files.length > 0 && item.files.map(file => {
        this.product.relatedFiles.push({
          id: file.file_id,
          file: <a download={`${file.original_name}`} href={`${BASE_URL}/files/${file.name}`} target="_blank">{file.original_name}</a>
        })
      })
    });
  };

  handleRelatedFileDelete = (fileId) => {
    const { notify } = this.context;
    this.props.inventoryProductStore.removeRelatedFiles(this.product.id, fileId)
      .then(res => {
        this.product.relatedFiles = this.product.relatedFiles.filter(file => +file.id !== +fileId);
        notify.success(res);
      }).catch(console.log);
  };

  deleteImage = e => {
    let { notify } = this.context;
    let fileId = e.target.id;
    let { inventoryProductStore } = this.props;

    // console.log(stationStore.items.filter(station => station.id==this.props.params.id)[0]);
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (confirm('Delete file?')) {
      inventoryProductStore.imageRemove(this.product.id, fileId).then(res => {
        this.product.images = this.product.images.filter(station => +station.id !== +fileId);
        notify.success(res);
      }).catch(notify.error);
    }
  };

  resetImages = (id) => {
    this.fetchProduct(id)
  };

  render() {
    return (
      <div>
        {this.product.images ?
          <div className='flex flex-row space-around'>
            {this.product.images.map((image, i) =>
              <div key={image.name + i} className="imageContainer">
                <div className="imageRemove"><span id={image.id} className="fa fa-remove" onClick={this.deleteImage} />
                </div>
                <img src={`${BASE_URL}/images/${image.name}`} style={{ height: '200px' }} alt='not-found' />
              </div>
            )}
          </div> :
          <Dropzone destination={`/api/inventory/product/${this.product.id}/image/upload`} context={this} id={this.product.id} resetImages={this.resetImages} />}
        <DataTable
          data={toJS(this.product.relatedFiles)}
          slug={this.relatedFilesSlug}
          columns={[
            { key: 'file', label: `Product ${this.product.name} Related Files` },
          ]}
          onDelete={this.handleRelatedFileDelete}
          allowAdd
          allowDelete
        />
        {this.props.children && React.cloneElement(this.props.children, { fetchSelectedItem: this.fetchProduct })}
      </div>
    );
  }
}

export default ProdctRelatedFileList;


// WEBPACK FOOTER //
// ./src/components/Inventory/ProdctRelatedFileList.js